<script lang="ts">
import useValidate from "@vuelidate/core"
import { FormService } from "../../../packages/datakode/nuxt-datakode-utils/services/form.service"

export default {
    props: {
        disabled: { type: Boolean, required: true },
        translationName: { type: String, required: true },
        selectedData: { type: Object, required: true },
    },
    emits: ["loadData"],
    data() {
        return {
            saving: false,
            loading: false,
            validationRules: null,
            v$: useValidate(),
            toSave: {},
        }
    },
    computed: {
        currentValidations() {
            if (this.selectedData && this.validationRules) {
                return (new FormService()).getVuelidateRules(this.validationRules)
            }
            return null
        },
        data() {
            return this.toSave as Record<string, any>
        },
    },
    mounted() {
        this.toSave = {}
    },
    validations() {
        return {
            ...this.currentValidations,
        }
    },
    methods: {
        async setupArchiveRecordMassEdit() {
            this.loading = true
            // Get single item to get validation rules
            try {
                const res = await this.$api.getData({ url: "archive-records/create", method: "GET" })
                this.validationRules = this.getRules(res.meta.rules)
                // Set common data in fields
                for (const r of Object.keys(res.meta.rules)) {
                    if (typeof this.selectedData[0][r] === "undefined") {
                        continue
                    }
                    this.toSave[r] = this.selectedData[0][r]
                    for (const item of this.selectedData) {
                        if (item[r] !== this.toSave[r]) {
                            delete this.toSave[r]
                            break
                        }
                    }
                }
                if (this.$refs.massEdit) {
                    this.$refs.massEdit.showModal()
                }
            }
            catch (e) {
                this.$showToaster({ title: "Edition de masse", text: `Impossible d'obtenir les données nécéssaires : ${e?.response?._data?.message}`, color: "warning", icon: "mdi-alert" })
            }

            this.loading = false
        },
        getRules(rules) {
            const res = []
            if (!rules) {
                return res
            }
            Object.keys(rules).forEach((rule) => {
                res[rule] = rules[rule].split("|")
            })
            return res
        },
        async saveArchiveRecordsMassEdit() {
            this.saving = true
            // set data on each item
            let records = [...this.selectedData]
            Object.keys(this.toSave).forEach((k) => {
                records = records.map((r) => {
                    r[k] = this.toSave[k]
                    return r
                })
            })
            try {
                await this.$api.setRequest({
                    url: "archive-records/mass-edit-save",
                    method: "POST",
                    body: records,
                }, true)
                this.saving = false
                this.$refs.massEdit.closeModal()
                this.$showToaster({ title: "Edition de masse", text: "Les données ont été enregistrées", color: "success", icon: "mdi-check-circle" })
                this.$emit("loadData")
            }
            catch (e) {
                this.saving = false
                this.$showToaster({ title: "Edition de masse", text: `Impossible d'enregistrer vos changements : ${e?.response?._data?.message}`, color: "warning", icon: "mdi-alert" })
            }
        },
        getStepDeclarationId(step) {
            return step.declarations.map(data => data.id)
        },
    },
}
</script>

<template>
    <v-tooltip text="Le bouton est activé lorsque au moins un dossier est sélectionné" :disabled="!disabled">
        <template #activator="{ props }">
            <v-btn
                v-bind="props" id="edition-masse-dossier" prepend-icon="mdi-format-list-group"
                :disabled color="primary" variant="outlined" class="mx-1 mb-5"
                :loading="loading"
                @click="setupArchiveRecordMassEdit"
            >
                Edition de masse <span v-if="selectedData.length" class="pl-1"> de {{ selectedData.length }} dossiers</span>
            </v-btn>
        </template>
    </v-tooltip>
    <ModalMiddle
        ref="massEdit"
        :saving="saving"
        permission-name="dossier"
        :is-form="true"
        save-text="Enregistrer"
        custom-button-block
        title-modal="Edition de masse"
        :hide-default-actions="false"
        @save="saveArchiveRecordsMassEdit"
    >
        <template #content>
            <v-alert class="mb-4 bg-light-blue-lighten-5">
                <p>Tous les éléments sélectionnés seront modifiés avec les données ci-dessous.</p>
                <p>Pour garder un champ inchangé, ne le modifiez pas sur ce formulaire</p>
                <div>
                    Dossiers à modifier :

                    <ul id="dossierlist">
                        <li v-for="d in selectedData" :key="d.id">
                            <RouterLink :to="`/dossiers/${d.id}`" target="_blank">
                                <strong>{{ d.cote }}</strong>
                            </RouterLink>
                        </li>
                    </ul>
                </div>
            </v-alert>
            <FormDossiersMassEdit
                :data
                translation-name="dossiers"
                :is-form="true"
                :validation="v$"
                :validation-rules="validationRules"
                @update-data="toSave = { ...toSave, ...$event }"
            />
        </template>
    </ModalMiddle>
</template>

<style>
#dossierlist {
    display: inline;
    list-style: none;
}

#dossierlist li {
    display: inline;
}
#dossierlist li + li:before {
    content: ", ";
}
#edition-masse-dossier {
    pointer-events: all;
}
</style>
